(function () {
    'use strict';

    angular.module('ib-meals-box-module', [
        'ib-web-ancillaries-services-module'
    ]);
})();